<div [loading]="loading">
  <ul>
    <li *ngFor="let ownership of data.list.list" class="ownership">
      {{ownership.podilCitatel}} / {{ownership.podilJmenovatel}}{{ownership.typravNazev ? ' (' + ownership.typravNazev + ")" : ''}}
      <div>{{ownership.subject | subjectName}}</div>
    </li>
  </ul>
  <div *ngIf="data.list.list?.length === 0">Žádní vlastníci</div>
</div>
